import { compose, withHandlers, withProps, withPropsOnChange, withState } from 'recompose';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';

import { withFormName } from '../../../../common/hoc/withFormName';
import SummaryCheckbox from './SummaryCheckbox';
import {
  canUpdatePermission,
  getSummaryCheckboxValue,
  isDependenciesChanged,
  updateDependentPermissions,
} from './helpers';
import withPermissions from '../../../../auth/utils/withPermissions';

const enhance = compose(
  withPermissions,
  withFormName,
  connect(
    (state, ownProps) => ({
      formValues: getFormValues(ownProps.form)(state),
    }),
    { change }
  ),
  withState(
    'summaryCheckboxValue',
    'setSummaryCheckboxValue',
      props => getSummaryCheckboxValue(props.dependencies, props.formValues)),
  withProps(props => ({
    disabled: props.dependencies.some(
      dependency => !canUpdatePermission(dependency.fieldName, { permissions: props.permissions })
    ),
  })),
  withHandlers({
    onSummaryCheckboxValueChange: props => (e) => {
      const newValue = e.target.checked;

      props.setSummaryCheckboxValue(newValue);

      const permissionsMask = { permissions: props.permissions };
      props.dependencies.forEach((dependency) => {
        if (canUpdatePermission(dependency.fieldName, permissionsMask)) {
          props.change(props.form, dependency.fieldName, newValue);

          updateDependentPermissions({
            permissionData: dependency,
            newPermissionValue: newValue,
            formName: props.form,
            changeFormValue: props.change,
          });
        }
      });
    },
  }),
  withPropsOnChange(
    (prevProps, nextProps) => (
      nextProps.formValues !== prevProps.formValues
      && isDependenciesChanged(nextProps.dependencies, prevProps.formValues, nextProps.formValues)
    ),
    (props) => {
      props.setSummaryCheckboxValue(getSummaryCheckboxValue(props.dependencies, props.formValues));
    },
  )
);

export default enhance(SummaryCheckbox);
